import { defineStore } from 'pinia';
import { connect, updateToken } from '@/utils/socket';
import { serverUrls } from '@/api/constants';
import { useUserStore } from './userStore';

export const useSocketStore = defineStore('socket', {
  state: () => ({
    socket: null,
    connected: false,
  }),
  actions: {
    initSocket() {
      const userStore = useUserStore();
      const token = userStore.keycloak?.token;

      if (!token) {
        console.warn('No Keycloak token available for WebSocket connection');
        return null;
      }

      if (!this.socket) {
        this.socket = connect(serverUrls.authUrl, token);

        this.socket.on('connect', () => {
          console.log('Socket connected');
          this.connected = true;
        });

        this.socket.on('disconnect', (reason) => {
          console.log('Socket disconnected: ', reason);
          this.connected = false;
        });

        this.socket.on('error', (error) => {
          console.error('Socket error:', error);
        });
      }

      return this.socket;
    },

    // Mettre à jour le token lors du rafraîchissement
    refreshToken(newToken) {
      if (this.socket && newToken) {
        updateToken(newToken);
      }
    },

    disconnect() {
      if (this.socket) {
        this.socket.disconnect();
        this.socket = null;
        this.connected = false;
      }
    },
  },
});
